module.exports = __webpack_public_path__ + "img/label_nearly_zero.b0b0cfb8.png";